export function isS3Endpoint(endpoint: string) {
  return endpoint.indexOf('s3.amazonaws.com') >= 0 || endpoint.indexOf('s3-accelerate.amazonaws.com') >= 0;
}
